"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionSignalBaseSchema = exports.IComponentFunctionSignalChildBusMappingSchema = void 0;
const zod_1 = require("zod");
const ComponentFunctionBusType_1 = require("./ComponentFunctionBusType");
const SignalDirection_1 = require("../DesignModels/SignalDirection");
exports.IComponentFunctionSignalChildBusMappingSchema = zod_1.z.object({
    childBusName: zod_1.z.string(),
    childSignalName: zod_1.z.string(),
});
exports.IComponentFunctionSignalBaseSchema = zod_1.z.object({
    name: zod_1.z.string(),
    optional: zod_1.z.boolean().optional(),
    isMultiAssignment: zod_1.z.boolean().optional(),
    busType: ComponentFunctionBusType_1.ComponentFunctionBusTypeSchema.optional(),
    busRole: zod_1.z.string().optional(),
    signalTypes: zod_1.z.lazy(() => SignalDirection_1.SignalDirectionSchema.array().optional()),
    childBusMapping: exports.IComponentFunctionSignalChildBusMappingSchema.optional(),
});
//# sourceMappingURL=IComponentFunctionSignalBase.js.map